enum WonOfferStatus {
    Confirmed = 1,
    Cancelled = 2,
    ConfirmedTms = 5,
}

export default WonOfferStatus;
